import pagination from '../../utils/pagination'
import {
  INVOICES_BATCH_DELETE_REQUEST, INVOICES_BATCH_DELETE_SUCCESS, INVOICES_BATCH_DELETE_FAILURE,
  INVOICES_FETCH_MANY_REQUEST, INVOICES_FETCH_MANY_SUCCESS, INVOICES_FETCH_MANY_FAILURE,
  INVOICES_FETCH_REQUEST, INVOICES_FETCH_SUCCESS, INVOICES_FETCH_FAILURE,
  INVOICES_SAVE_REQUEST, INVOICES_SAVE_SUCCESS, INVOICES_SAVE_FAILURE,

  EMPTY_INVOICES,
  CLEAR_ERRORS
} from './types'

export default {
  [INVOICES_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [INVOICES_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [INVOICES_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [INVOICES_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [INVOICES_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [INVOICES_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [INVOICES_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [INVOICES_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [INVOICES_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [INVOICES_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [INVOICES_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [INVOICES_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_INVOICES] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
